<template>
  <div class="app-router">
    <h2 class="font-weight-bold">Deposit Reseller</h2>
    <div class="text-subtitle-2 pb-4">Berikut ini adalah ringkasan informasi Deposit Reseller.</div>

    <v-layout v-resize="onResize" column>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card flat outlined>
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row class="align-center">
                <v-col cols="12" sm="7" class="py-0 d-flex flex-row align-center justify-start">
                  <v-img width="20" class="mr-4" src="/assets/seller/total-saldo-icon.svg"></v-img>
                  <h3 class="mb-0">
                    <span class="d-block text-caption">Total Saldo</span>
                    <span v-if="saldoDepositReseller">{{ saldoDepositReseller | toRupiah }}</span>
                    <span v-else>Rp 0</span>
                  </h3>
                </v-col>
                <v-col cols="12" sm="5" class="py-0" :class="(isMobile) ? 'mt-4' : 'text-right'">
                  <!-- {{saldoDepositReseller}} -->
                  <v-btn
                    :disabled="(saldoDepositReseller === 0) || (saldoDepositReseller && parseFloat(saldoDepositReseller) <= 0 && detailStore)"
                    color="black"
                    :loading="loadingProcess"
                    class="white--text"
                    :class="{'v-btn--block': isMobile}"
                    @click="dialogWithdrawReq = true"
                  >
                    <span class="text-subtitle-2 text-capitalize font-weight-bold">Tarik Saldo</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <hr />
            <!-- <v-card-text>
              <v-row>
                <v-col cols="6" class="py-1">Total Penghasilan</v-col>
                <v-col cols="6" class="py-1 text-right font-weight-bold">
                  <template v-if="saldo">{{ saldo.total_in | toRupiah }}</template>
                  <template v-else>Rp 0</template>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="py-1">Total Yang Sudah Ditarik</v-col>
                <v-col cols="6" class="py-1 text-right font-weight-bold">
                  <template v-if="saldo">{{ saldo.total_out | toRupiah }}</template>
                  <template v-else>Rp 0</template>
                </v-col>
              </v-row>
            </v-card-text>-->
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card flat outlined>
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row class="align-center">
                <v-col cols="10" class="py-0">
                  Riwayat Saldo
                  <div class="text-caption d-block" v-if="filter.dateRange">
                    Periode :
                    <strong>{{ formatDateText(filter.dateRange[0], 'DD MMM YYYY') }} - {{ formatDateText(filter.dateRange[1], 'DD MMM YYYY') }}</strong>
                  </div>
                </v-col>
                <v-col cols="2" class="py-0 text-right">
                  <v-btn
                    fab
                    small
                    outlined
                    elevation="0"
                    color="grey"
                    @click="dialogSetPeriods = true"
                  >
                    <v-icon>mdi-cog-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <hr />
            <v-card-text>
              <v-tabs grow v-model="intabs">
                <v-tab class="text-caption font-weight-bold">Mutasi Dana</v-tab>
                <v-tab class="text-caption font-weight-bold">Penarikan Dana</v-tab>

                <v-tab-item>
                  <div class="d-block px-0 py-5">
                    <!-- {{depositResellerMutasi}} -->

                    <v-simple-table>
                      <tbody v-if="!loading">
                        <template v-if="depositResellerMutasi && depositResellerMutasi.length > 0">
                          <template v-for="(mutasi, idx) in depositResellerMutasi">
                            <tr :key="idx" v-if="!isMobile">
                              <td width="50%" class="pa-3">
                                <div
                                  class="text-subtitle-2 text-capitalize font-weight-bold black--text"
                                >{{ mutasi.deposit_cash_log_note | emptyData }}</div>
                                <span
                                  class="text-caption"
                                >{{ formatDateText(mutasi.deposit_cash_log_datetime, 'DD MMM YYYY HH:mm') }}</span>
                              </td>
                              <td width="50%" class="pa-3 text-right">
                                <div
                                  class="text-subtitle-2 font-weight-bold green--text"
                                  v-if="mutasi.deposit_cash_log_type=='in'"
                                >+ {{ mutasi.deposit_cash_log_value | toRupiah }}</div>
                                <div
                                  class="text-subtitle-2 font-weight-bold red--text"
                                  v-else
                                >- {{ mutasi.deposit_cash_log_value | toRupiah }}</div>
                                <!-- <span
                                  class="text-caption"
                                >Saldo {{ mutasi.store_balance_value | toRupiah }}</span>-->
                              </td>
                            </tr>

                            <tr :key="idx" v-else>
                              <td class="pa-3">
                                <div
                                  class="text-subtitle-2 text-capitalize font-weight-bold black--text"
                                >{{ mutasi.deposit_cash_log_note | emptyData }}</div>
                                <span
                                  class="text-caption"
                                >{{ formatDateText(mutasi.deposit_cash_log_datetime, 'DD MMM YYYY HH:mm') }}</span>
                                <v-divider class="my-2"></v-divider>
                                <div
                                  class="text-subtitle-2 font-weight-bold green--text"
                                  v-if="mutasi.deposit_cash_log_type=='in'"
                                >+ {{ mutasi.deposit_cash_log_value | toRupiah }}</div>
                                <div
                                  class="text-subtitle-2 font-weight-bold red--text"
                                  v-else
                                >- {{ mutasi.deposit_cash_log_value | toRupiah }}</div>
                                <!-- <span
                                  class="text-caption"
                                >Saldo {{ mutasi.store_balance_value | toRupiah }}</span>-->
                              </td>
                            </tr>
                          </template>
                        </template>

                        <template v-else>
                          <tr>
                            <td colspan="2" class="py-5">
                              <div
                                class="d-flex flex-column pa-5 align-center text-center justify-center"
                              >
                                <v-img
                                  width="150"
                                  max-width="150"
                                  class="mr-4"
                                  src="/assets/seller/ilus-tdk-ada-transaksi.svg"
                                ></v-img>
                                <div
                                  class="text-subtitle-2 font-weight-medium black--text mt-3"
                                >Tidak Ada Transaksi Pada Periode Waktu Ini.</div>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>

                      <tbody v-else>
                        <tr>
                          <td colspan="2">
                            <div
                              class="d-flex flex-column pa-5 align-center text-center justify-center"
                            >Loading...</div>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <v-pagination
                      v-if="mutasiPagination.total_page > 1 && depositResellerMutasi"
                      @input="updateMutasiPage"
                      v-model="page"
                      :length="mutasiPagination.total_page"
                      total-visible="7"
                      circle
                      class="d-flex justify-end no-button-focus py-2"
                    ></v-pagination>
                  </div>
                </v-tab-item>

                <v-tab-item>
                  <div class="d-block px-0 py-5">
                    <v-simple-table>
                      <tbody v-if="!loading">
                        <template v-if="saldoWithdraw && saldoWithdraw.length > 0">
                          <template v-for="(tarik, idx) in saldoWithdraw">
                            <tr :key="idx" v-if="!isMobile">
                              <td width="50%" class="pa-3">
                                <div
                                  class="text-subtitle-2 text-capitalize font-weight-bold black--text"
                                >Penarikan Dana ke Bank {{ tarik.store_withdrawal_to_bank_name }} an. {{ tarik.store_withdrawal_to_bank_account_name }} {{ tarik.store_withdrawal_to_bank_account_number }}</div>
                                <!-- <span
                                  class="text-caption"
                                  v-if="tarik.store_withdrawal_status=='paid'"
                                >{{ formatDateText(tarik.store_withdrawal_status_paid_datetime, 'DD MMM YYYY HH:mm') }}</span>
                                <span
                                  class="text-caption"
                                  v-else-if="tarik.store_withdrawal_status=='rejected'"
                                >{{ formatDateText(tarik.store_withdrawal_status_rejected_datetime, 'DD MMM YYYY HH:mm') }}</span>-->
                                <span
                                  class="text-caption"
                                >{{ formatDateText(tarik.store_withdrawal_status_created_datetime, 'DD MMM YYYY HH:mm') }}</span>
                              </td>
                              <td width="50%" class="pa-3 text-right">
                                <div
                                  class="d-block text-subtitle-2 font-weight-bold red--text"
                                >{{ tarik.store_withdrawal_value | toRupiah }}</div>
                                <v-chip
                                  x-small
                                  label
                                  class="mt-2 font-weight-bold"
                                  :class="colorStatus(tarik.store_withdrawal_status)"
                                >{{ statusCaption(tarik.store_withdrawal_status) }}</v-chip>
                                <div
                                  class="text-caption"
                                  v-if="tarik.store_withdrawal_status=='paid'"
                                >{{ formatDateText(tarik.store_withdrawal_status_paid_datetime, 'DD MMM YYYY HH:mm') }}</div>
                                <div
                                  class="text-caption"
                                  v-else-if="tarik.store_withdrawal_status=='rejected'"
                                >{{ formatDateText(tarik.store_withdrawal_status_rejected_datetime, 'DD MMM YYYY HH:mm') }}</div>
                              </td>
                            </tr>

                            <tr :key="idx" v-else>
                              <td class="pa-3">
                                <v-chip
                                  small
                                  block
                                  label
                                  class="mb-2 font-weight-bold"
                                  :class="colorStatus(tarik.store_withdrawal_status)"
                                >{{ statusCaption(tarik.store_withdrawal_status) }}</v-chip>
                                <div
                                  class="text-caption"
                                  v-if="tarik.store_withdrawal_status=='paid'"
                                >{{ formatDateText(tarik.store_withdrawal_status_paid_datetime, 'DD MMM YYYY HH:mm') }}</div>
                                <div
                                  class="text-caption"
                                  v-else-if="tarik.store_withdrawal_status=='rejected'"
                                >{{ formatDateText(tarik.store_withdrawal_status_rejected_datetime, 'DD MMM YYYY HH:mm') }}</div>
                                <div
                                  class="text-subtitle-2 text-capitalize font-weight-bold black--text"
                                >Penarikan Dana ke Bank {{ tarik.store_withdrawal_to_bank_name }} an. {{ tarik.store_withdrawal_to_bank_account_name }} {{ tarik.store_withdrawal_to_bank_account_number }}</div>
                                <!-- <span
                                  class="text-caption"
                                  v-if="tarik.store_withdrawal_status=='paid'"
                                >{{ formatDateText(tarik.store_withdrawal_status_paid_datetime, 'DD MMM YYYY HH:mm') }}</span>
                                <span
                                  class="text-caption"
                                  v-else-if="tarik.store_withdrawal_status=='rejected'"
                                >{{ formatDateText(tarik.store_withdrawal_status_rejected_datetime, 'DD MMM YYYY HH:mm') }}</span>-->
                                <span
                                  class="text-caption"
                                >{{ formatDateText(tarik.store_withdrawal_status_created_datetime, 'DD MMM YYYY HH:mm') }}</span>
                                <v-divider class="my-2"></v-divider>
                                <div
                                  class="d-block text-subtitle-2 font-weight-bold red--text"
                                >{{ tarik.store_withdrawal_value | toRupiah }}</div>
                              </td>
                            </tr>
                          </template>
                        </template>

                        <template v-else>
                          <tr>
                            <td colspan="2" class="py-5">
                              <div
                                class="d-flex flex-column pa-5 align-center text-center justify-center"
                              >
                                <v-img
                                  width="150"
                                  max-width="150"
                                  class="mr-4"
                                  src="/assets/seller/ilus-tdk-ada-transaksi.svg"
                                ></v-img>
                                <div
                                  class="text-subtitle-2 font-weight-medium black--text mt-3"
                                >Tidak Ada Transaksi Pada Periode Waktu Ini.</div>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>

                      <tbody v-else>
                        <tr>
                          <td colspan="2">
                            <div
                              class="d-flex flex-column pa-5 align-center text-center justify-center"
                            >Loading...</div>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <v-pagination
                      v-if="withdrawPagination.total_page > 1 && saldoWithdraw"
                      @input="updateWithdrawPage"
                      v-model="page"
                      :length="withdrawPagination.total_page"
                      total-visible="7"
                      circle
                      class="d-flex justify-end no-button-focus py-2"
                    ></v-pagination>
                  </div>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-dialog v-model="dialogSelisihDiscount" persistent max-width="50%">
      <!-- {{dataPreview.po_detail_id_arr}} -->
      <v-card>
        <v-card-title class="d-block text-h6 text-h6 text-capitalize green--text">
          <div class="d-flex flex-row align-center justify-space-between pb-0">
            Detil Selisih Diskon
            <v-btn
              class="d-block red--text font-weight-bold"
              small
              fab
              text
              elevation="0"
              @click="dialogSelisihDiscount = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1">
          <div>Peringkat Reseller: {{dataPreview.current_type | uppercase}}</div>
          <div>Total Belanja: {{dataPreview.total_purchase | toRupiah}}</div>
          <v-simple-table>
            <thead>
              <tr>
                <!-- <th style="width:30px;">No.</th> -->
                <th>Kode Transaksi</th>
                <th>Nama</th>
                <th>Diskon</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="dataPreview.po_detail_id_arr.length">
                <template v-for="(item,idx) in dataPreview.po_detail_id_arr">
                  <tr v-if="item.selisih_disc>0" :key="idx">
                    <!-- <td>{{idx}}</td> -->
                    <td>{{item.po_code}}</td>
                    <td>({{item.po_detail_product_code}}) {{item.po_detail_product_name}}</td>
                    <td>
                      {{(item.current_disc-item.selisih_disc) | toRupiah}}
                      <br />
                      <small>
                        <strike>{{item.current_disc | toRupiah}}</strike>
                      </small>
                    </td>

                    <!-- <td>{{item.po_code}}</td>
                  <td>{{((item.po_detail_product_code!='')?item.po_detail_product_code+'-':'')}}{{item.item.po_detail_product_name}}</td>
                  <td>{{item.current_disc | toRupiah}}</td>
                  <td>{{(item.current_disc-item.selisih_disc) | toRupiah}}</td>
                    <td>{{item.selisih_disc | toRupiah}}</td>-->
                  </tr>
                </template>
              </template>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogWithdrawReq" persistent max-width="500">
      <v-card>
        <v-card-title class="d-block text-h6 text-h6 text-capitalize green--text">
          <div class="d-flex flex-row align-center justify-space-between pb-0">
            Penarikan
            <v-btn
              class="d-block red--text font-weight-bold"
              small
              fab
              text
              elevation="0"
              @click="cancelWithdraw"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1">
          <v-alert
            color="red"
            type="error"
            class="mb-3"
            dismissible
            v-if="responseError.value"
          >{{ responseError.value }}</v-alert>
          <template v-if="widthdrawStep === 0">
            <v-form ref="formWithdraw" role="form">
              <div class="d-flex flex-column justify-start mb-5">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Tarik Saldo ke</div>
                <v-autocomplete
                  v-model="withdraw.bank"
                  :items="bankList"
                  return-object
                  placeholder="Pilih bank tujuan penarikan"
                  hide-details="auto"
                  item-value="bank_name"
                  outlined
                  dense
                  :rules="bankCodeRules"
                >
                  <template v-slot:selection="data">
                    <div class="d-flex flex-row align-center justify-left">
                      <!-- <v-img width="60" max-width="60" class="mr-0" :src="(data.item.bank_logo) ? data.item.bank_logo : '/assets/product/default.png'"></v-img> -->
                      <div class="d-flex flex-column px-3">
                        <strong>{{ data.item.bank_name }}</strong>
                      </div>
                      <div class="d-flex flex-column text-subtitle-1">
                        <div class="font-weight-bold">{{ data.item.bank_account_number }}</div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:item="data">
                    <div class="d-flex flex-row align-center justify-left">
                      <!-- <v-img width="60" max-width="60" class="mr-0" :src="(data.item.bank_logo) ? data.item.bank_logo : '/assets/product/default.png'"></v-img> -->
                      <div class="d-flex flex-column px-3">
                        <strong>{{ data.item.bank_name }}</strong>
                      </div>
                      <div class="d-flex flex-column text-subtitle-1">
                        <div class="font-weight-bold">{{ data.item.bank_account_number }}</div>
                      </div>
                    </div>
                  </template>
                </v-autocomplete>
              </div>
              <hr class="mb-3" />

              <div class="d-flex flex-column justify-start">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Jumlah Penarikan Dana</div>
                <v-currency-field
                  v-model="withdraw.value"
                  hide-details="auto"
                  dense
                  :rules="valueRules"
                  class="d-flex align-center"
                >
                  <template v-slot:prepend>
                    <div class="text-h6 font-weight-bold grey--text pr-2">Rp</div>
                  </template>
                </v-currency-field>
              </div>

              <div class="d-flex flex-column justify-start">
                <v-checkbox
                  v-model="useSaldo"
                  color="green"
                  hide-details="auto"
                  @change="(useSaldo) ? withdraw.value = saldoDepositReseller : withdraw.value = 0"
                >
                  <template v-slot:label>
                    <div>
                      Tarik saldo saat ini
                      <span :class="{'d-block mt-1': isMobile}">
                        (
                        <strong class="green--text">{{ saldoDepositReseller | toRupiah }}</strong>)
                      </span>
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </v-form>
          </template>

          <template v-if="widthdrawStep === 1">
            <div class="d-flex flex-column justify-start mb-3">
              <div class="d-block text-subtitle-2 font-weight-bold black--text mb-2">Tarik Saldo ke</div>
              <div class="d-flex flex-row align-center justify-left" v-if="withdraw.bank">
                <!-- <v-img width="60" max-width="60" class="mr-0" :src="(withdraw.bank.bank_logo) ? withdraw.bank.bank_logo : '/assets/product/default.png'"></v-img> -->
                <div class="d-flex flex-column pr-3">
                  <strong>{{withdraw.bank.bank_name }}</strong>
                </div>
                <div class="d-flex flex-column text-subtitle-1">
                  <div class="font-weight-bold">({{withdraw.bank.bank_account_number }})</div>
                </div>
              </div>
              <div class="d-block py-2 px-0 red--text" v-else>Bank tujuan transfer belum dipilih.</div>
            </div>
            <hr class="mb-3" />

            <v-row>
              <!-- {{dataPreview}} -->
              <v-col cols="6" class="py-2">
                <div class="d-block text-subtitle-2 black--text">Jumlah Penarikan Dana</div>
              </v-col>
              <v-col cols="6" class="py-2 text-right">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text"
                >{{ withdraw.value | toRupiah }}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-2">
                <div class="d-block text-subtitle-2 black--text">Selisih Diskon</div>
              </v-col>
              <v-col cols="6" class="py-2 text-right">
                <div class="d-block text-subtitle-2 font-weight-bold red--text">
                  <a
                    v-if="dataPreview.selisih_discount>0"
                    @click="dialogSelisihDiscount = true"
                    href="javascript:void(0)"
                    class="red--text"
                  >- {{dataPreview.selisih_discount | toRupiah}}</a>
                  <span v-else>0</span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-2">
                <div class="d-block text-subtitle-2 black--text">Biaya Admin (5%)</div>
              </v-col>
              <v-col cols="6" class="py-2 text-right">
                <div
                  class="d-block text-subtitle-2 font-weight-bold red--text"
                >- {{dataPreview.fee_admin | toRupiah}}</div>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col cols="6" class="py-2">
                <div class="d-block text-subtitle-2 black--text">Jumlah Transfer Ke Bank</div>
              </v-col>
              <v-col cols="6" class="py-2 text-right">
                <div
                  class="d-block text-h6 font-weight-bold green--text"
                >{{dataPreview.nett | toRupiah }}</div>
              </v-col>
            </v-row>
          </template>

          <template v-if="widthdrawStep === 2">
            <v-form ref="formWithdrawAuth" role="form">
              <div class="d-flex flex-column justify-start">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Konfirmasi Akun Anda</div>
                <v-text-field
                  @click:append="showPassword"
                  :type="passwordType"
                  :rules="passwordRules"
                  v-model="authSeller"
                  validate-on-blur
                  single-line
                  outlined
                  class="color-primary rounded-lg password-field"
                  dense
                  :append-icon="passwordIcon"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </v-form>
          </template>

          <template v-if="widthdrawStep === 3">
            <div class="d-flex flex-column align-center justify-center">
              <v-img width="60" max-width="60" class="mb-4" src="/assets/seller/checklist.png"></v-img>
              <div class="d-flex flex-column text-subtitle-1 text-center mb-0">
                <div
                  class="font-weight-bold"
                >Penarikan telah berhasil. Silahkan menunggu proses oleh sistem selama 1x24 jam.</div>
              </div>
            </div>
          </template>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <template v-if="widthdrawStep === 0">
              <v-btn
                color="green"
                :loading="loadingProcess"
                class="my-2 px-5 ml-2 text-capitalize white--text"
                @click="withdrawValidation"
              >Lanjutkan</v-btn>
            </template>

            <template v-if="widthdrawStep === 1">
              <v-btn
                color="black"
                :loading="loadingProcess"
                class="my-2 px-5 ml-2 text-capitalize white--text"
                @click="widthdrawConfirm"
              >Proses</v-btn>
            </template>

            <template v-if="widthdrawStep === 2">
              <v-btn
                color="green"
                :loading="loadingProcess"
                class="my-2 px-5 ml-2 text-capitalize white--text"
                @click="validateUser()"
              >Proses</v-btn>
            </template>

            <template v-if="widthdrawStep === 3">
              <v-btn
                outlined
                color="black"
                :loading="loadingProcess"
                class="my-2 px-5 ml-2 text-capitalize white--text"
                @click="cancelWithdraw"
              >OK</v-btn>
            </template>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSetPeriods" persistent max-width="500">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text darken-4"
        >Setting Periode Mutasi</v-card-title>
        <v-card-text class="py-0 px-5">
          <p>Ubah periode untuk melihat riwayat mutasi saldo anda</p>
          <v-menu
            ref="menuDate"
            v-model="menuDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details="auto"
                outlined
                clearable
                densed
                class="datePickerSmall"
                placeholder="Periode Mutasi Saldo"
                @click:clear="clearDate"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filter.dateRange" no-title range @change="setPeriodChange">
              <v-spacer></v-spacer>
              <div class="d-flex flex-row justify-center pb-3 pt-0">
                <v-btn outlined small color="blue darken-1" @click="menuDate = false">Batal</v-btn>
                <v-btn
                  color="blue darken-1"
                  small
                  class="white--text ml-2"
                  @click="$refs.menuDate.save(filter.dateRange)"
                >OK</v-btn>
              </div>
            </v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center mt-3">
            <hr />
            <v-btn
              outlined
              :loading="loadingProcess"
              @click="cancelDate"
              class="my-2 px-5 mr-2 text-capitalize"
            >Batal</v-btn>
            <v-btn
              color="black"
              :loading="loadingProcess"
              :disabled="(filter.dateRange.length<2)"
              @click="setMutasiPeriods"
              class="my-2 px-5 text-capitalize white--text font-weight-bold"
            >OK</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "penghasilan-saya",
  data() {
    return {
      dialogSelisihDiscount: false,
      dataPreview: {
        current_type: "",
        current_rank: 0,
        reseller_type_by_purchase: "",
        rank_by_purchase: 0,
        total_purchase: "",
        total_discount_all: 0,
        po_detail_id_arr: [
          {
            po_detail_id: "",
            po_code: "",
            po_detail_product_code: "",
            po_detail_product_name: "",
            current_disc: 0,
            selisih_disc: 0
          }
        ],
        gross: "",
        fee_admin: 0,
        selisih_discount: 0,
        nett: 0
      },
      intabs: null,
      isMobile: false,
      dialogWithdrawReq: false,
      dialogSetPeriods: false,
      loadingProcess: false,
      loading: false,
      widthdrawStep: 0,
      withdraw: {
        bank: null,
        value: 0
      },
      useSaldo: false,
      authSeller: null,
      passwordType: "password",
      passwordIcon: "mdi-eye",
      bankCodeRules: [v => !!v || "Pilihan Bank tidak boleh kosong"],
      valueRules: [
        v => !!v || "Nilai dana yang ditarik tidak boleh kosong",
        v =>
          parseFloat(v.replace(/\D/g, "")) < this.saldoDepositReseller + 1 ||
          "Nilai dana yang ditarik tidak boleh melebihi saldo yang tersedia",
        v => parseInt(v) > 0 || "Nilai dana yang ditarik harus lebih dari 0"
      ],
      passwordRules: [v => !!v || "Password tidak boleh kosong"],
      bankList: [
        {
          bank_logo: "",
          bank_account_name: "",
          bank_account_number: "",
          bank_name: "",
          bank_branch: ""
        }
      ],
      page: 1,
      limit: 10,
      sort: {},
      sortBy: "",
      sortDir: "",
      periodMutasiFilter: {
        value: "",
        comparison: "bet",
        type: "date",
        field: "store_balance_datetime"
      },
      periodTarikFilter: {
        value: "",
        comparison: "bet",
        type: "date",
        field: "store_withdrawal_status_created_datetime"
      },
      filter: {
        dateRange: []
      },
      menuDate: false
    };
  },

  computed: {
    ...mapState("cart", ["saldoDepositReseller"]),
    ...mapState("saldoSeller", [
      "depositResellerMutasi",
      "saldoDepositResellerArr",
      "saldo",
      "saldoMutasi",
      "saldoWithdraw",
      "mutasiPagination",
      "withdrawPagination",
      "response",
      "responseError"
    ]),
    ...mapState("storeSeller", ["detailStore"]),
    dateRangeText: {
      get() {
        let dates1 = this.filter.dateRange[0]
          ? new Date(this.filter.dateRange[0])
          : null;
        let dates2 = this.filter.dateRange[1]
          ? new Date(this.filter.dateRange[1])
          : null;
        return (
          moment(dates1).format("DD MMM YYYY") +
          " - " +
          moment(dates2).format("DD MMM YYYY")
        );
      },
      set() {
        let dates1 = this.filter.dateRange[0]
          ? new Date(this.filter.dateRange[0])
          : null;
        let dates2 = this.filter.dateRange[1]
          ? new Date(this.filter.dateRange[1])
          : null;
        return (
          moment(dates1).format("DD MMM YYYY") +
          " - " +
          moment(dates2).format("DD MMM YYYY")
        );
      }
    }
  },
  filters: {
    uppercase: function(v) {
      return v.toUpperCase();
    }
  },
  methods: {
    ...mapActions("cart", ["getSaldoDepositReseller"]),
    ...mapActions("saldoSeller", [
      "getSaldoSummaryDepositReseller",
      "getSaldoSummary",
      "getDepositResellerMutasi",
      "getSaldoMutasi",
      "getWithdrawDepositReseller",
      "requestWithdrawDepositReseller",
      "previewWithdrawDepositReseller",
      "success"
    ]),
    ...mapActions("storeSeller", ["getStoreDetail"]),

    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },

    setPeriodChange() {
      const sortedDates = this.filter.dateRange.sort((a, b) => {
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
      });

      this.periodMutasiFilter.value = this.setPeriodFilter(sortedDates);
      this.periodTarikFilter.value = this.setPeriodFilter(sortedDates);
    },

    async defaultPeriods() {
      let inPeriods = await new Date();
      let lastDate = await new Date(
        inPeriods.getFullYear(),
        inPeriods.getMonth() + 1,
        0
      );
      let firstDate = await new Date(
        inPeriods.getFullYear(),
        inPeriods.getMonth(),
        1
      );
      this.filter.dateRange = await [];
      await this.filter.dateRange.push(
        moment(firstDate).format("YYYY-MM-DD"),
        moment(lastDate).format("YYYY-MM-DD")
      );
      this.periodMutasiFilter.value = this.setPeriodFilter(
        this.filter.dateRange
      );
      this.periodTarikFilter.value = this.setPeriodFilter(
        this.filter.dateRange
      );
    },

    clearDate() {
      this.defaultPeriods();
    },

    cancelDate() {
      this.defaultPeriods();
      this.dialogSetPeriods = false;
    },

    setPeriodFilter(dates) {
      if (dates)
        return (
          moment(dates[0]).format("YYYY-MM-DD") +
          "::" +
          moment(dates[1]).format("YYYY-MM-DD")
        );
    },

    statusCaption(status) {
      if (status === "paid") return "Sudah Dibayar";
      else if (status === "rejected") return "Dibatalkan";
      else return "Menunggu Transfer";
    },

    colorStatus(status) {
      if (status === "paid") return "green white--text";
      else if (status === "rejected") return "grey lighten-3 red--text";
      else return "grey lighten-3 black--text";
    },

    showPassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.passwordIcon = "mdi-eye-off";
      } else {
        this.passwordType = "password";
        this.passwordIcon = "mdi-eye";
      }
    },

    async loadMutasi() {
      let params = await [];
      let params2 = await [];
      if (this.periodMutasiFilter.value) params.push(this.periodMutasiFilter);
      if (this.periodTarikFilter.value) params2.push(this.periodTarikFilter);

      // await this.getSaldoSummary();
      await this.getSaldoSummaryDepositReseller();
      // await this.getSaldoMutasi(
      await this.getDepositResellerMutasi(
        this.queryString({ limit: 10, page: 1, params: params })
      );
      await this.getWithdrawDepositReseller(
        this.queryString({ limit: 10, page: 1, params: params2 })
      );
    },

    async updateMutasiPage(val) {
      this.loading = await true;
      let params = await [];
      if (this.periodMutasiFilter.value) params.push(this.periodMutasiFilter);

      // await this.getSaldoMutasi(
      await this.getDepositResellerMutasi(
        this.queryString({ limit: 10, page: val, params: params })
      ).then(() => {
        this.loading = false;
      });
    },

    async updateWithdrawPage(val) {
      this.loading = await true;
      let params = await [];
      if (this.periodTarikFilter.value) params.push(this.periodTarikFilter);

      await this.getWithdrawDepositReseller(
        this.queryString({ limit: 10, page: val })
      ).then(() => {
        this.loading = false;
      });
    },

    async setMutasiPeriods() {
      this.loadingProcess = await true;
      await this.loadMutasi();
      this.loadingProcess = await false;
      this.dialogSetPeriods = false;
    },

    withdrawValidation() {
      if (this.$refs.formWithdraw.validate()) {
        this.previewWidthdrawConfirm();
      }
    },

    async cancelWithdraw() {
      this.loadingProcess = await true;
      let params = await [];
      let params2 = await [];
      if (this.periodMutasiFilter.value) params.push(this.periodMutasiFilter);
      if (this.periodTarikFilter.value) params2.push(this.periodTarikFilter);
      this.withdraw = await {
        bank: null,
        value: 0
      };
      this.dialogWithdrawReq = await false;
      this.widthdrawStep = await 0;
      await this.success({});
      // await this.getSaldoSummary();
      await this.getSaldoSummaryDepositReseller();
      // await this.getSaldoMutasi(
      await this.getDepositResellerMutasi(
        this.queryString({ limit: 10, page: 1, params: params })
      );
      await this.getWithdrawDepositReseller(
        this.queryString({ limit: 10, page: 1, params: params2 })
      );
      this.loadingProcess = false;
    },
    async previewWidthdrawConfirm() {
      this.loadingProcess = await true;
      let params = await {
        value: this.withdraw.value
      };
      this.previewWithdrawDepositReseller(params)
        .then(async response => {
          // console.log("resss", response);
          this.dataPreview = response.data;
          this.loading = await true;
          this.loadMutasi();
          this.loadingProcess = await false;
          this.loading = await false;
          this.widthdrawStep = 1;
        })
        .catch(() => {
          this.widthdrawStep = 0;
          this.loadingProcess = false;
        });
    },
    async widthdrawConfirm() {
      this.loadingProcess = await true;
      let params = await {
        value: this.withdraw.value
      };
      this.requestWithdrawDepositReseller(params)
        .then(async () => {
          this.loading = await true;
          this.getSaldoDepositReseller();
          this.loadMutasi();
          this.loadingProcess = await false;
          this.loading = await false;
          this.widthdrawStep = 3;
        })
        .catch(() => {
          this.loadingProcess = false;
        });
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },

  async created() {
    this.loading = await true;
    this.$store.dispatch("setPageTitle", `Penghasilan Saya`);
    await this.defaultPeriods();
    await this.loadMutasi();
    this.bankList = await [];
    await this.getStoreDetail();
    await this.bankList.push({
      bank_logo: "",
      bank_account_name: this.detailStore.store_bank_account_name,
      bank_account_number: this.detailStore.store_bank_account_number,
      bank_name: this.detailStore.store_bank_name,
      bank_branch: this.detailStore.store_bank_branch
    });
    this.getSaldoDepositReseller();
    this.loading = false;
  }
};
</script>